import * as z from 'zod'

export const favoriteSchema = z
  .object({
    path: z.string(),
    name: z.string(),
    color: z.string().optional(),
    iconName: z.string().optional(),
    // If set, we can get the color and icon from the plugin
    entityType: z.string().optional(),
    /** Opaque entity id — used by Dashboard Phase 2 pin tracking to dedup against the
     * Recently-updated / Continue-working sections without re-deriving from `path`. */
    entityId: z.string().describe('Entity id for dashboard pin tracking').optional(),
    /** Explicit favorite flag. Legacy entries without this field are treated as
     * `true` (their presence in the array is the favorite signal). Required for the
     * Phase 2 model where an entry can exist as pinned-only without being a favorite. */
    favorite: z.boolean().describe('Explicit favorite flag (legacy entries default to true)').optional(),
    /** Phase 2: whether this entry is pinned to the dashboard. */
    pinned: z.boolean().describe('Pinned to dashboard top shelf').optional(),
    /** Phase 2: sort order within the Pinned section. Lower = earlier. */
    pinOrder: z.number().describe('Sort order within the Pinned section').optional(),
  })
  .describe('Page name and path')

// Used to support legacy favorites (i.e., entity IDs)
export const favoriteSchemaLegacy = z.union([z.string().describe('Entity ID'), favoriteSchema])

export type Favorite = z.infer<typeof favoriteSchema>
